export default __webpack_public_path__ + "static/sweatshirt-results-4-7f0aca5d488dcd8864144d26f75e283f.png";